import React, { FC } from "react";
import VODAdminLayout from "../../../layouts/admin/VODAdminLayout";

const VODAdminHomeView: FC = () => {
    return (
        <>
            <VODAdminLayout heading="VOD">
                <div className="h-full flex flex-col mr-6">
                </div>
            </VODAdminLayout>
        </>
    );
};

export default VODAdminHomeView;